import { Box } from '@factorialco/deprecated-design-system'

import { GridItem } from './GridItem'

export function Skeleton() {
  return (
    <Box paddingLeft="s48" paddingBottom="s32">
      <Box flexDirection="row">
        <GridItem.Skeleton position="7" />
        <GridItem.Skeleton position="8" />
        <GridItem.Skeleton position="9" />
      </Box>
      <Box flexDirection="row">
        <GridItem.Skeleton position="4" />
        <GridItem.Skeleton position="5" />
        <GridItem.Skeleton position="6" />
      </Box>
      <Box flexDirection="row">
        <GridItem.Skeleton position="1" />
        <GridItem.Skeleton position="2" />
        <GridItem.Skeleton position="3" />
      </Box>
    </Box>
  )
}
